import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { AbvPbmRateForm } from './AbvPbmRateForm'

export const AbvPbmRateDetail = () => {

  const tabSpecs = [
    { id: 'info', label: 'Info', content: <AbvPbmRateForm /> }
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}